import { ACTION } from "src/util/utils";
import {
  BCU_CLEAN_IMPORT_LAYOUT,
  BCU_IMPORT_FILE,
  BCU_IMPORT_FILE_FAILED,
  BCU_IMPORT_FILE_SUCCESS,
  KEYS,
  MODULE_KEY,
  BCU_UPDATE_VALIDATED_IMPORT,
  BCU_UPDATE_VALIDATED_IMPORT_FAILED,
  BCU_UPDATE_VALIDATED_IMPORT_SUCCESS,
} from "./actions";

export const REDUCER_KEY = KEYS[MODULE_KEY + ACTION.STATE_KEY];

export interface IBulkCostUpdateState {
  loading: boolean;
  error: any;
  data: [];
  importLoading: boolean;
  importFailed: boolean;
  importValidationData: any[];
}

const defaultState: IBulkCostUpdateState = {
  loading: false,
  error: null,
  data: [],
  importLoading: false,
  importFailed: false,
  importValidationData: [],
};

export const bulkCostUpdateReducer = (
  state = defaultState,
  { type, payload }: any
) => {
  switch (type) {
    case KEYS[MODULE_KEY + ACTION.FETCH]:
      return {
        ...state,
        loading: true,
      };

    case KEYS[MODULE_KEY + ACTION.SUCCESS]:
      return {
        ...state,
        loading: false,
        data: [...payload],
      };
    case KEYS[MODULE_KEY + ACTION.FAILED]:
      return {
        ...state,
        loading: false,
        error: payload,
      };
    case BCU_IMPORT_FILE: {
      return {
        ...state,
        importLoading: true,
      };
    }
    case BCU_IMPORT_FILE_SUCCESS: {
      return {
        ...state,
        importLoading: false,
        importFailed: false,
        importValidationData: payload,
      };
    }
    case BCU_IMPORT_FILE_FAILED: {
      return {
        ...state,
        importLoading: false,
        importFailed: true,
        importValidationData: payload,
      };
    }
    case BCU_UPDATE_VALIDATED_IMPORT: {
      return {
        ...state,
        importLoading: true,
      };
    }
    case BCU_UPDATE_VALIDATED_IMPORT_SUCCESS:
    case BCU_UPDATE_VALIDATED_IMPORT_FAILED: {
      return {
        ...state,
        importLoading: false,
      };
    }
    case BCU_CLEAN_IMPORT_LAYOUT: {
      return {
        ...state,
        importLoading: false,
        importFailed: false,
        importValidationData: [],
      };
    }

    default:
      return state;
  }
};
